import VariableSearchPanel from 'components/editor/variables/VariableSearchPanel';
import Stack from '@mui/material/Stack';

export function Variables() {
  return (
    <Stack direction="column" pb={6}>
      <VariableSearchPanel isEditor={false} />
    </Stack>
  );
}
